import { axios, BaseApiUrl } from '../axios_config';

// 获取移动端进仓单库存
export const getDeliveryInventory = params =>{
    return axios.get(`${BaseApiUrl}/TFMobile/GetDeliveryInventory`, { params }).then(res => res.data);
}
// 提交换库位操作
export const deliveryInventoryChange = params =>{
    return axios.post(`${BaseApiUrl}/TFMobile/DeliveryInventoryChange`, { ...params }).then(res => res.data);
}
